var _defs, _path, _rect, _rect2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNamaz0(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Namaz-0_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61 196.24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Namaz-0_svg__cls-1,.Namaz-0_svg__cls-2{fill:#fdb515;stroke:#c4820e;stroke-miterlimit:10}.Namaz-0_svg__cls-2{fill:none;stroke-width:.1em}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-0_svg__cls-1",
    d: "M180 82.76A30 30 0 10143.12 112v10.27a20.24 20.24 0 00-13.37 19v33.5a20.24 20.24 0 0012 18.46 8.47 8.47 0 00-.46 2.77v43a8.75 8.75 0 0017.5 0v-43a8.47 8.47 0 00-.46-2.77 20.24 20.24 0 0012-18.46v-33.5a20.24 20.24 0 00-13.37-19V112A30 30 0 00180 82.76z",
    transform: "translate(-119.5 -52.01)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "Namaz-0_svg__cls-1",
    x: 140.32,
    y: 121.56,
    width: 16.01,
    height: 31.27,
    rx: 8.01,
    transform: "rotate(26.88 197.376 -138.846)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "Namaz-0_svg__cls-1",
    x: 128.86,
    y: 128.36,
    width: 16.01,
    height: 31.27,
    rx: 8.01,
    transform: "rotate(90 103.115 58.245)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-0_svg__cls-2",
    d: "M120.75 74.26s.74-8.21 1.36-10.32c4.32-14.58 20.94-15.74 26.41-2.21.92 2.26 2 12.53 2 12.53z",
    transform: "translate(-119.5 -52.01)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-0_svg__cls-2",
    d: "M121.5 74.26s.73-8.21 1.36-10.32c4.31-14.58 20.93-15.74 26.41-2.21.91 2.26 2 12.53 2 12.53z",
    transform: "translate(-119.5 -52.01)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-0_svg__cls-2",
    d: "M122.36 74.26s.74-8.21 1.37-10.32c4.31-14.58 20.93-15.74 26.41-2.21.91 2.26 2 12.53 2 12.53z",
    transform: "translate(-119.5 -52.01)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-0_svg__cls-2",
    d: "M123.23 74.26s.74-8.21 1.36-10.32c4.32-14.58 20.94-15.74 26.42-2.21.91 2.26 2 12.53 2 12.53z",
    transform: "translate(-119.5 -52.01)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-0_svg__cls-2",
    d: "M124.1 74.26s.74-8.21 1.36-10.32c4.32-14.58 20.94-15.74 26.42-2.21.91 2.26 2 12.53 2 12.53z",
    transform: "translate(-119.5 -52.01)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-0_svg__cls-2",
    d: "M125.22 74.26s.74-8.21 1.36-10.32c4.32-14.58 20.94-15.74 26.42-2.21.91 2.26 2 12.53 2 12.53z",
    transform: "translate(-119.5 -52.01)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-0_svg__cls-2",
    d: "M126.34 74.26s.74-8.21 1.36-10.32c4.31-14.58 20.94-15.74 26.41-2.21.92 2.26 2 12.53 2 12.53z",
    transform: "translate(-119.5 -52.01)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-0_svg__cls-2",
    d: "M127.46 74.26s.73-8.21 1.36-10.32c4.31-14.58 20.93-15.74 26.41-2.21.92 2.26 2 12.53 2 12.53z",
    transform: "translate(-119.5 -52.01)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-0_svg__cls-2",
    d: "M128.2 74.26s.74-8.21 1.36-10.32c4.32-14.58 20.94-15.74 26.44-2.21.91 2.26 2 12.53 2 12.53z",
    transform: "translate(-119.5 -52.01)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-0_svg__cls-2",
    d: "M129.32 74.26s.74-8.21 1.36-10.32c4.32-14.58 20.94-15.74 26.41-2.21.92 2.26 2 12.53 2 12.53z",
    transform: "translate(-119.5 -52.01)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-0_svg__cls-2",
    d: "M130.31 74.26s.74-8.21 1.36-10.32c4.32-14.58 20.94-15.74 26.42-2.21.91 2.26 2 12.53 2 12.53z",
    transform: "translate(-119.5 -52.01)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-0_svg__cls-2",
    d: "M131.18 74.26s.74-8.21 1.36-10.32c4.32-14.58 20.94-15.74 26.42-2.21.91 2.26 2 12.53 2 12.53z",
    transform: "translate(-119.5 -52.01)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-0_svg__cls-2",
    d: "M131.93 74.26s.74-8.21 1.36-10.32c4.31-14.58 20.93-15.74 26.41-2.21.92 2.26 2 12.53 2 12.53z",
    transform: "translate(-119.5 -52.01)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-0_svg__cls-2",
    d: "M132.67 74.26s.74-8.21 1.36-10.32c4.32-14.58 20.94-15.74 26.42-2.21.91 2.26 2 12.53 2 12.53z",
    transform: "translate(-119.5 -52.01)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-0_svg__cls-2",
    d: "M133.79 74.26s.74-8.21 1.36-10.32c4.32-14.58 20.94-15.74 26.42-2.21.91 2.26 2 12.53 2 12.53z",
    transform: "translate(-119.5 -52.01)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-0_svg__cls-2",
    d: "M134.54 74.26s.73-8.21 1.36-10.32c4.31-14.58 20.93-15.74 26.41-2.21.92 2.26 2 12.53 2 12.53z",
    transform: "translate(-119.5 -52.01)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-0_svg__cls-2",
    d: "M135.65 74.26s.74-8.21 1.37-10.32c4.31-14.58 20.93-15.74 26.41-2.21.91 2.26 2 12.53 2 12.53z",
    transform: "translate(-119.5 -52.01)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-0_svg__cls-2",
    d: "M136.4 74.26s.74-8.21 1.36-10.32c4.32-14.58 20.94-15.74 26.41-2.21.92 2.26 2 12.53 2 12.53z",
    transform: "translate(-119.5 -52.01)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-0_svg__cls-2",
    d: "M137.27 74.26s.74-8.21 1.36-10.32c4.31-14.58 20.94-15.74 26.41-2.21.92 2.26 2 12.53 2 12.53z",
    transform: "translate(-119.5 -52.01)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-0_svg__cls-2",
    d: "M138.14 74.26s.74-8.21 1.36-10.32c4.31-14.58 20.93-15.74 26.41-2.21.92 2.26 2 12.53 2 12.53z",
    transform: "translate(-119.5 -52.01)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-0_svg__cls-2",
    d: "M139 74.26s.73-8.21 1.36-10.32c4.31-14.58 20.93-15.74 26.41-2.21.92 2.26 2 12.53 2 12.53z",
    transform: "translate(-119.5 -52.01)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-0_svg__cls-2",
    d: "M140.13 74.26s.73-8.21 1.36-10.32c4.31-14.58 20.93-15.74 26.41-2.21.91 2.26 2 12.53 2 12.53z",
    transform: "translate(-119.5 -52.01)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-0_svg__cls-2",
    d: "M141.24 74.26s.74-8.21 1.36-10.32c4.32-14.58 20.94-15.74 26.42-2.21.91 2.26 2 12.53 2 12.53z",
    transform: "translate(-119.5 -52.01)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-0_svg__cls-2",
    d: "M142 74.26s.74-8.21 1.36-10.32c4.31-14.58 20.93-15.74 26.41-2.21.92 2.26 2 12.53 2 12.53z",
    transform: "translate(-119.5 -52.01)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-0_svg__cls-2",
    d: "M143.11 74.26s.73-8.21 1.36-10.32c4.31-14.58 20.93-15.74 26.41-2.21.92 2.26 2 12.53 2 12.53z",
    transform: "translate(-119.5 -52.01)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-0_svg__cls-2",
    d: "M144.22 74.26s.74-8.21 1.37-10.32c4.31-14.58 20.93-15.74 26.41-2.21.91 2.26 2 12.53 2 12.53z",
    transform: "translate(-119.5 -52.01)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-0_svg__cls-2",
    d: "M145.22 74.26s.73-8.21 1.36-10.32c4.31-14.58 20.93-15.74 26.41-2.21.92 2.26 2 12.53 2 12.53z",
    transform: "translate(-119.5 -52.01)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-0_svg__cls-2",
    d: "M146.09 74.26s.73-8.21 1.36-10.32c4.31-14.58 20.93-15.74 26.41-2.21.92 2.26 2 12.53 2 12.53z",
    transform: "translate(-119.5 -52.01)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-0_svg__cls-2",
    d: "M146.83 74.26s.74-8.21 1.36-10.32c4.32-14.58 20.94-15.74 26.42-2.21.91 2.26 2 12.53 2 12.53z",
    transform: "translate(-119.5 -52.01)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-0_svg__cls-2",
    d: "M147.58 74.26s.73-8.21 1.36-10.32c4.31-14.58 20.93-15.74 26.41-2.21.92 2.26 2 12.53 2 12.53z",
    transform: "translate(-119.5 -52.01)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-0_svg__cls-2",
    d: "M148.7 74.26s.73-8.21 1.36-10.32c4.31-14.58 20.93-15.74 26.41-2.21.91 2.26 2 12.53 2 12.53z",
    transform: "translate(-119.5 -52.01)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-0_svg__cls-2",
    d: "M149.44 74.26s.74-8.21 1.36-10.32c4.32-14.58 20.94-15.74 26.42-2.21.91 2.26 2 12.53 2 12.53z",
    transform: "translate(-119.5 -52.01)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-0_svg__cls-2",
    d: "M149.44 74.26s.74-8.21 1.36-10.32c4.32-14.58 20.94-15.74 26.42-2.21.91 2.26 2 12.53 2 12.53z",
    transform: "translate(-119.5 -52.01)"
  })));
}

export default SvgNamaz0;